import { OrderIntentionOriginEnum } from 'enums/orderIntentionOrigin.enum';
import { OrderIntentionStatusEnum } from 'enums/orderIntentionStatus.enum';
import { OrderIntention } from 'model/OrderIntention';
import moment from 'moment';

export const canOpenJustification = (
  origin: string,
  status: string,
  justification: unknown,
) => {
  if (origin === OrderIntentionOriginEnum.DIRECT_SALE) {
    return true;
  }
  if (
    origin === OrderIntentionOriginEnum.ORDER_INTENTION &&
    (status === OrderIntentionStatusEnum.RECUSADO ||
      status === OrderIntentionStatusEnum.CONFIRMADO_PARCIAL)
  ) {
    return justification !== null;
  }
  return false;
};

export const isSelectionBlocked = (status: string, origin: string) => {
  if (
    origin === OrderIntentionOriginEnum.ORDER_INTENTION &&
    (status === OrderIntentionStatusEnum.EXPIRADO ||
      status === OrderIntentionStatusEnum.AGUARDANDO_PRODUTOR)
  ) {
    return false;
  }
  if (
    origin === OrderIntentionOriginEnum.DIRECT_SALE &&
    status === OrderIntentionStatusEnum.PENDENTE
  ) {
    return false;
  }
  return true;
};

export const hasMixedStatusOrOrigin = (data: OrderIntention[] | undefined) => {
  let countDiference = 0;
  let firstOriginOrder = '';
  let firstStatusOrder = '';

  if (data) {
    firstOriginOrder = data.length > 0 ? data[0].origin : '';
    firstStatusOrder = data.length > 0 ? data[0].status : '';
  }
  data?.forEach((order) => {
    if (
      order.origin !== firstOriginOrder ||
      order.status !== firstStatusOrder
    ) {
      countDiference += 1;
    }
  });

  return countDiference !== 0;
};

export const isDeliveryDateExpiredForRepublish = (deliveryDate: string) =>
  moment(deliveryDate).isBefore(moment().add(-1, 'day')) ||
  moment(deliveryDate).format('DD') === moment().add(-1, 'day').format('DD');

export const hasValidDeliveryDatesForRepublish = (items: OrderIntention[]) => {
  let irregularDates = 0;
  items.forEach((item) => {
    if (moment(item.deliveryDate).isBefore(moment().add(-1, 'day'))) {
      irregularDates += 1;
    }
  });
  return irregularDates === 0;
};

export const isShippingFeeBranch = (branch?: string) => branch === 'CVH_UB';
